export default __webpack_public_path__ + "static/media/caja firma.f28b4cd3.svg";